import { Loader2 } from "lucide-react";
import { cn } from "@/lib/cn";

/** Spinner centralizado pra estados de loading de tela inteira ou inline. */
export function Spinner({ className, fullscreen = false }: { className?: string; fullscreen?: boolean }) {
  const icon = <Loader2 className={cn("animate-spin text-accent-soft", className)} size={28} />;
  if (!fullscreen) return icon;
  return <div className="flex min-h-[50vh] items-center justify-center">{icon}</div>;
}
